import PasswordValidator from 'password-validator';

const validPassword = new PasswordValidator();

export const validatedPassword = (password: string) => {
  validPassword
    .is()
    .min(8)
    .has()
    .uppercase()
    .has()
    .not()
    .spaces()
    .has()
    .symbols()
    .has()
    .digits(1);

  if (validPassword.validate(password)) return true;

  return false;
};
